import React, {Component} from 'react';
import { Skeleton } from 'antd';
class SkeletonWrapper extends Component {
	render() {

		return <Skeleton {...this.props} active />
	}
}


export default SkeletonWrapper;